module.exports = __webpack_public_path__ + "img/p2-88.a431f6a1.png";